"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useButtonStyles = void 0;
var tslib_1 = require("tslib");
var styles_1 = require("@material-ui/core/styles");
var commons_1 = require("../../../style/commons");
var containedBaseStyles = function (bgHover, color, backgroundColor) {
    if (color === void 0) { color = 'white'; }
    if (backgroundColor === void 0) { backgroundColor = 'none'; }
    return ({
        color: color,
        borderRadius: 8,
        backgroundColor: backgroundColor,
        '&:hover': {
            backgroundColor: bgHover,
        },
    });
};
exports.useButtonStyles = (0, styles_1.makeStyles)(function () { return ({
    root: {
        textTransform: 'none',
        width: '100%',
        padding: 16,
        boxShadow: '0px 2px 4px 2px rgba(146, 173, 204, 0.25)',
    },
    content: {
        outline: 'none',
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'row',
        gap: 16,
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    },
    text: {
        width: '100%',
        textAlign: 'left',
    },
    title: {
        fontWeight: 500,
    },
    containedPrimary: tslib_1.__assign(tslib_1.__assign({}, containedBaseStyles(commons_1.mediumPrimary, 'white', commons_1.primaryColor)), { '&:focus': {
            borderColor: 'white',
            border: '4px solid',
            boxShadow: "0 0 0 4px ".concat(commons_1.darkPrimary, ",") + "0.3em 0.3em 1em rgba(146,173,204,0.24)",
        } }),
    containedSecondary: tslib_1.__assign(tslib_1.__assign({}, containedBaseStyles(commons_1.secondaryColor, commons_1.darkPrimary, commons_1.lightSecondary)), { border: '1px solid', borderColor: commons_1.darkPrimary, '&:focus': {
            borderColor: 'white',
            border: '4px solid',
            boxShadow: "0 0 0 4px ".concat(commons_1.darkPrimary, ",") + "0.3em 0.3em 1em rgba(146,173,204,0.24)",
        } }),
    containedTertiary: tslib_1.__assign(tslib_1.__assign({}, containedBaseStyles(commons_1.lightBlue, commons_1.darkSecondary, commons_1.white)), { border: '1px solid', borderColor: commons_1.brandPrimaryAlternative, '& .rightIcon': {
            padding: 0,
            border: 'none',
        }, '& .leftIcon': {
            border: "1px solid ".concat(commons_1.brandPrimaryAlternative),
            borderRadius: '4px',
            padding: 11,
            height: 48,
            width: 48,
        }, '& .subtitle': {
            color: commons_1.darkPrimary,
        }, '&:hover': {
            backgroundColor: commons_1.secondaryHover,
            borderColor: commons_1.brandPrimaryDarkAlternative,
            border: '1px solid',
        }, '&:focus': {
            backgroundColor: commons_1.secondaryColor,
            borderColor: commons_1.brandPrimaryMaxDark,
            border: '1px solid',
        } }),
    disabledContainedPrimary: {
        opacity: '0.4',
        backgroundColor: "".concat(commons_1.primaryColor, " !important"),
        color: 'white !important',
    },
    disabledContainedSecondary: {
        opacity: '0.4',
        borderColor: '#7373FC',
        backgroundColor: "".concat(commons_1.white, " !important"),
        color: "".concat(commons_1.mediumSecondary, " !important"),
    },
    disabledContainedTertiary: {
        opacity: '0.4',
        backgroundColor: "".concat(commons_1.white, " !important"),
        color: "".concat(commons_1.mediumSecondary, " !important"),
    },
}); });
